/**
 * Shared "session expired, redirecting to login" flag.
 *
 * Lives in its own module (not the interceptor, not UiService) because both
 * need it and the interceptor already imports UiService — putting it in
 * either would create an import cycle that dependency-cruiser forbids.
 *
 * While set, UiService suppresses further snackbars so component-level error
 * handlers (which fire right after the interceptor on a 401) can't replace
 * the friendly "session expired" toast with a raw backend message.
 * AuthTokenService re-arms the flag when a new session starts.
 */
let expired = false;

export function markSessionExpiredRedirect(): void {
  expired = true;
}

export function clearSessionExpiredRedirect(): void {
  expired = false;
}

export function isSessionExpiredRedirect(): boolean {
  return expired;
}
